import React, { useEffect, useState } from "react";
import { getTopCompletedFormsByFormId } from "../../api/work-order-formsAPI";

const FormsTopCompletedByFormTable = () => {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRows = async () => {
      try {
        setIsLoading(true);
        const response = await getTopCompletedFormsByFormId();
        setRows(Array.isArray(response) ? response : []);
      } catch (err) {
        console.error("Failed to load top completed forms by form", err);
        setError("Unable to load top completed forms");
      } finally {
        setIsLoading(false);
      }
    };

    fetchRows();
  }, []);

  return (
    <div className='col-xxl-8'>
      <div className='card h-100'>
        <div className='card-body p-24 d-flex flex-column gap-16'>
          <h6 className='mb-0 fw-bold text-lg'>Top 10 Completed Forms</h6>
          {isLoading ? (
            <div className='d-flex align-items-center justify-content-center py-5'>
              <span className='text-secondary-600 text-sm'>Loading table...</span>
            </div>
          ) : error ? (
            <div className='d-flex align-items-center justify-content-center py-5'>
              <span className='text-danger-main text-sm'>{error}</span>
            </div>
          ) : rows.length === 0 ? (
            <div className='d-flex align-items-center justify-content-center py-5'>
              <span className='text-secondary-600 text-sm'>No completed forms to display.</span>
            </div>
          ) : (
            <div className='table-responsive'>
              <table className='table bordered-table mb-0'>
                <thead>
                  <tr>
                    <th scope='col'>Rank</th>
                    <th scope='col'>Name</th>
                    <th scope='col'>Type</th>
                    <th scope='col' className='text-end'>Count</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row, index) => (
                    <tr key={`${row.formId ?? "unknown"}-${index}`}>
                      <td>{index + 1}</td>
                      <td>{row.formName ?? "Unknown Form"}</td>
                      <td>{row.formTypeName ?? "Uncategorised"}</td>
                      <td className='text-end'>{Number(row.count ?? 0)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FormsTopCompletedByFormTable;
